<div class="w-full p-6 flex flex-col gap-4 justify-around items-center h-full">
  <div></div>

  <div class="w-full flex flex-col gap-2 justify-center items-center">
    <div class="text-general-tiltle2 px-10 text-center text-(--color-text-primary)">
      {{ data.title ?? 'Permiso de ubicación requerido' }}
    </div>

    <div class="text-general px-6 text-center">
      {{ data.message }}
    </div>

    <div
      class="size-30 shrink-0! items-center justify-center rounded-lg m-3 flex"
      [style.background-color]="data.iconBackground ?? '#fdecea'"
    >
      <span class="material-symbols-outlined text-8xl!" [style.color]="data.iconColor ?? '#c62828'">
        {{ data.icon ?? 'location_off' }}
      </span>
    </div>
  </div>

  <div class="w-full flex flex-col gap-2 justify-center items-center">
    <button class="button-general w-full" matButton="filled" (click)="close()">
      <div class="flex items-center gap-2">
        {{ data.actionText ?? 'Entendido' }}
      </div>
    </button>
  </div>
</div>
